/**
 * 위차 로고 — 가이드북 v3.0 의 공식 좌표를 그대로 옮긴 것.
 *
 * 심볼은 상승 게이지 넉 줄 + 시안 점(충전을 뜻한다), 워드마크는 소문자 wecha 아웃라인이다.
 * 글자를 폰트로 다시 치지 않는다 — 가이드북 규정이고, 폰트가 없는 기계에서 모양이 바뀐다.
 *
 * 앱(wecha-front)의 Brand 컴포넌트와 같은 좌표를 쓴다. 콘솔만 다른 로고를 그리면 두 화면이
 * 다른 제품으로 보인다.
 */
const GAUGE = [
  { d: "M 14 88 L 31 71", color: "#0B2E6B" },
  { d: "M 38 80 L 55 63", color: "#1A56C4" },
  { d: "M 62 72 L 79 55", color: "#2E8BE6" },
  { d: "M 86 64 L 103 47", color: "#36CFF5" },
];

export function LogoMark({ size = 22 }: { size?: number }) {
  return (
    <svg width={size * (105 / 54)} height={size} viewBox="0 0 105 54" aria-hidden>
      <g transform="translate(-7.5,-40.5)">
        {GAUGE.map((g) => (
          <path key={g.d} d={g.d} stroke={g.color} strokeWidth={13} strokeLinecap="round" />
        ))}
        <circle cx={106} cy={78} r={6.5} fill="#36CFF5" />
      </g>
    </svg>
  );
}

/** 심볼 + 이름. 사이드바 머리에 쓴다. */
export function BrandLockup() {
  return (
    <div className="flex items-center gap-2">
      <LogoMark size={20} />
      <span className="text-[15px] font-bold tracking-tight text-foreground">
        wecha <span className="font-semibold text-muted-foreground">CSMS</span>
      </span>
    </div>
  );
}
